import { LinkingOptions, getStateFromPath } from "@react-navigation/native";
import {
  PrivateStackParamList,
  PublicParamList,
  SimpleUserStackParamList,
} from "./types";

// Item pages used to open at "/MenuDetailRefactor?business=..&table=..&menuKey=..", which matched no screen,
// so reloading them or going back to them landed on the landing page. Keep those links (browser history,
// restored tabs) working by rewriting them to the current path.
const LEGACY_MENU_ITEM_PATH = /^\/?MenuDetailRefactor\?(.*)$/;

const rewriteLegacyPath = (path: string) => {
  const match = path.match(LEGACY_MENU_ITEM_PATH);
  if (!match) return path;

  const query: Record<string, string> = {};
  match[1].split("&").forEach((pair) => {
    const [name, value = ""] = pair.split("=");
    query[decodeURIComponent(name)] = decodeURIComponent(value);
  });
  const { business, table, menuKey } = query;
  if (!business || !table || !menuKey) return path;

  return `menu-item/${encodeURIComponent(business)}/${encodeURIComponent(table)}/${encodeURIComponent(menuKey)}`;
};

export const linking: LinkingOptions<
  PrivateStackParamList & PublicParamList & SimpleUserStackParamList
> = {
  prefixes: [
    "https://agenda-roko.web.app/",
    "myapp://",
    "https://agenda-roko.web.app/",
    "https://192.168.1.65:19006/",
  ],
  getStateFromPath: (path, options) => getStateFromPath(rewriteLegacyPath(path), options),
  config: {
    screens: {
      Root: {
        screens: {
          Home: "home",
          Profile: "profile",
          Stats: "stats",
        },
      },
      Menu: "menu/:business/:table",
      MenuDetail: "menu-detail/:business/:table/:menuKey",
      MenuDetailRefactor: "menu-item/:business/:table/:menuKey",
      Cart: "cart/:business/:table",
      EditMenu: "edit-menu/:key/:type",
      EditTable: "edit-table/:key/:type",
      EditStaff: "edit-staff/:key/:type",
      StaffDetail: "staff-detail/:key/:type",
      EditTranslations: "edit-translations",
      LandingPage: "",
      Login: "login",
      Register: "register",
      Orders: "orders",
      OrderDetail: "order-detail/:key",
      OrderStatus: "order-status/:key/:uid",
      Settings: "settings",
    },
  },
};
